import React from "react";
import { Link } from "react-router-dom";
// import { signOut } from "firebase/auth";
// import { auth } from "../firebase-config";
// import logo from "../assets/aboutimages/LogoTuckerFinnWebDev.png";
import labLogo from "../assets/aboutimages/Labrador Logo.png";
import chiLogo from "../assets/aboutimages/LogoTuckerFinnWebDev.png";

const Footer = ({ isAuth, setIsAuth }) => {
  // const signUserOut = () => {
  //   signOut(auth).then(() => {
  //     localStorage.clear();
  //     setIsAuth(false);
  //     window.location.pathname = "/login";
  //   });
  // };

  const today = new Date();
  const dayOfMonth = today.getDate(); // Gets they day of the month (1-31)
  let logo; // Creates empty variable to fill with upcoming if-statement
  if (dayOfMonth % 2 === 0) {
    logo = chiLogo
  } else {
    logo = labLogo
  }

  return (
    <footer>
      <div className="footerInfo">
        <img src={logo} alt="Tucker, Finn, and Company Logo" style={{ width: '100px', height: 'auto' }} />
        <div className="footerDescription">
          <p>Tyler Olsen's Salesforce Portfolio</p>
          <p>&copy; 2025 Tucker, Finn, and Company Web Developers</p>
        </div>
        <div className="footerLink">
          <Link to="/Certifications">Certifications</Link>
          <Link to="/Superbadges">Superbadges</Link>
          <Link to="/useCases">Use Cases</Link>
          <Link to="/Contact">Contact</Link>
          {/* <Link to="/Blog">Blog</Link> */}
          <Link to="/About">About</Link>
      {/* {!isAuth ? (
        <Link to="/login">Login</Link>
      ) : (
        <>
          <Link to="/createpost">Create Post</Link>
          <button onClick={signUserOut}>Log Out</button>
        </>
      )}           */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;